import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import getShareableFormUrl from 'forms-utils-lib/urls/public/getShareableFormUrl';
// @ts-expect-error: no types
import encodeToken from 'forms-embed-utils-lib/share/encodeToken';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ShareLink({
  embedVersion,
  formGuid,
  onClickPreviewLink,
  onCopyShareLink
}) {
  const shareableLink = `${getShareableFormUrl()}/${encodeToken(formGuid, PortalIdParser.get(), embedVersion === EmbedVersions.V4 ? 2 : 1)}`;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "share-link-body",
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "assetActionsLibForms.modals.shareDialog.shareLink.message"
      })
    }), /*#__PURE__*/_jsx(CopyInput, {
      "data-test-id": "share-link-copy-input",
      value: shareableLink,
      inputProps: {
        readOnly: true
      },
      onCopy: onCopyShareLink
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "300",
      children: /*#__PURE__*/_jsx(Link, {
        "data-test-id": "share-link-preview",
        external: true,
        onClick: onClickPreviewLink,
        href: shareableLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.shareDialog.shareLink.preview"
        })
      })
    })]
  });
}